import type { ProductBehavior } from '@up2stay/up2promo-api-client';
import { TARGET_KIND_OPTIONS } from '@up2stay/up2promo-commons/products';
import {
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@up2stay/up2promo-ui';

import { useId } from 'react';

import type { ProductsDict } from '@/routes/app/products/products.types';

export type ProductFormBehaviourFieldProps = {
  value: ProductBehavior | string;
  onChange: (v: ProductBehavior) => void;
  dict: ProductsDict | undefined;
};

export function ProductFormBehaviourField({
  value,
  onChange,
  dict,
}: ProductFormBehaviourFieldProps) {
  const labelId = useId();
  return (
    <div className="space-y-0.5 min-w-0 w-full">
      <Label id={labelId}>{dict?.edit?.behaviour}</Label>
      <Select
        value={value}
        onValueChange={(v) => onChange(v as ProductBehavior)}
      >
        <SelectTrigger aria-labelledby={labelId}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {TARGET_KIND_OPTIONS.map((opt) => (
            <SelectItem key={opt.value} value={opt.value}>
              {dict?.edit?.[opt.labelKey] ?? opt.value}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
